import React, {useState, useRef, useEffect} from 'react'
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel';
import "./category-wise-bulk.scss";
import CategorySearchSlider from '../add-edit-product/CategorySearchSlider';
import Button from 'jd-library/Button';
import Loader from 'jd-library/Loader';

import { identifyAuditFlow, productCatCapitalize } from '../../utills';

const CategoryWiseBulk = (props) =>{
    let inputRef = useRef(null);
    let catSliderRef = useRef(null);
    const [showCatSlider, setShowCatSlider] = useState(false);
    const [finalUrl,setFinalUrl] = useState('');
    const sourceCheck = identifyAuditFlow({query: true});
    
    const openCloseCatSlider = (flag) => {
        props.setBypassScreen(true);
        setShowCatSlider(flag);
    };  

    const onSelectCategory = (e, catData, options = {}) => {
        props.setCatData(catData);
        setShowCatSlider(false);
    };
    const downloadSampleFile = (url) => {
        if(props.isJdSourceIOS || props.isJdBusinessIOS){

            url = 'https://download_pdf.php?url='+url;
        }
        window.location.href = url;
    }    
    const prepareUrl = async () => {
        const url = `/marketplace/static/php/web/b2bWebsite.php?token=${props.session.token}&action=downloadSamplefile&urlType=downloadFileOmni&${props.bulkUploadServices? `bulkType=service` : `transactionType=${props.session.newProfile == 4 && !props.bulkUploadServices ? 'receiveenquiry' : props.transactionType}`}&keywordId=${props.catData.keywordId}&keywordName=${props.catData.name}`;
        console.log('url', url);
        if (props.isJdSourceIOS || props.isJdBusinessIOS) {
            const source = sourceCheck?.source || props.session?.userSource;
            const urlToSend = url + `&source=${source}`;
            const iosUrl = await axios.get(urlToSend);
            const iosFilePath = iosUrl.data?.filePath;
            setFinalUrl(iosFilePath);
        } else {
            setFinalUrl(url);    
        }
    }    
    useEffect(() => {
        prepareUrl();
    },[props.catData.keywordId]);
    
    return (
        <>
            <div className="category-wise-container">
                <div className="category-wise-step-holder">
                    <div className="category-wise-subtext">
                        <span>STEP 1</span>
                    </div>
                    <div className="category-wise-text">
                        <span>{`Select the ${props.bulkUploadServices?'Service':'Product'} Category`}</span>
                    </div>
                    <div className="category-wise-subtext">
                        <InputWithMovingLabel
                            label={`${props.bulkUploadServices?'Service':'Product'} Category`}
                            holderClass={'category-slider-input'}
                            input= {{
                                value : productCatCapitalize(props.catData.name) || '',
                                onChange: (e) => handleChange(e, "categoryName"),
                                readOnly: true,
                                onClick: () => {openCloseCatSlider(true)},
                                disabled: props.catData.name ? 'disabled' : ''
                            }}
                            className={props.catData.name ? 'disable-input' : ''}
                            key = {'categoryName'}
                            ref={inputRef}
                            errorMessage={''}
                            rightIconClass= {`cat-input-icon ${props.catData.name ? 'icon-HDRcross' : 'icon-Next'}`}
                            onRightIconClick = {() => {openCloseCatSlider(true)}}
                        />
                    </div>
                </div>
                {props.catData ?
                    <>
                        <div className="category-wise-step-holder second">
                            <div className="category-wise-subtext">
                                <span>STEP 2</span>
                            </div>
                            <div className="category-wise-text mgb-5">
                                <div>Download File Format for <span className="category-wise-bold">{props.catData.name}</span> Category</div>
                            </div>
                            <div className="category-wise-info">
                                <span>Download and fill up the required columns in the excel file.</span>
                            </div>
                            <div className="category-wise-btn-holder">
                                <Button
                                    size={'md'}
                                    showLoader={false}
                                    className={'upload-btn' + (props.showLoader ? ' with-loader': '')}
                                    onClick={() => downloadSampleFile(finalUrl)}
                                >
                                    Download Excel File   
                                </Button>
                            </div>
                        </div>
                        <div className="category-wise-step-upload">
                            <div className="category-wise-subtext">
                                <span>STEP 3</span>
                            </div>
                            <div className="category-wise-text">
                                <div>Upload File for <span className="category-wise-bold">{props.catData.name}</span> Category</div>
                            </div>
                            <div className="category-wise-btn-holder">
                                <Button
                                    size={'md'}
                                    // showLoader={props.isUploadBtnLoader}
                                    onClick={()=>props.uploadBtnClick(props.bulkUploadServices)}
                                    className={'upload-btn' + (props.isUploadBtnLoader ? ' with-loader': '')}
                                >
                                    {props.isUploadBtnLoader ?
                                        (
                                            <div>
                                                <Loader className='upload-btn-loader'/> Uploading
                                            </div>
                                        ):
                                        'Upload File' 
                                    }
                                    
                                </Button>
                            </div>
                        </div>    
                    </>
                    :null
                }
            </div>
            {showCatSlider ? (
                <CategorySearchSlider
                    ref={catSliderRef}
                    onSelectCategory={onSelectCategory}
                    productName={''}
                    catSliderShown={showCatSlider}
                    closeSlider={() => openCloseCatSlider(false)}
                    categoryName={''}
                    keywordName={''}
                    showToastMessage={props.showToastMessage}
                    oType={
                        props.bulkUploadServices ? 'SERVICE' : ''
                    }
                    hintText= {'Enter Category Name'}
                    hintCustomClass= {'category-hint'}
                    fromBulkUpload={true}
                    isAddProduct={true}
                />
            ) : null}
        </>
    )
}

export default CategoryWiseBulk;
